import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Polls the current URL on an interval and Turbo-visits to refresh
// in place. Replaces the meta http-equiv="refresh" tag we used to ship
// on the runs#show page — that tag fires a wall-clock browser timer
// that survives Turbo navigations, so clicking away during the 10s
// window yanked the user back to the run page.
//
// Wire up with (identifier is predict-auto-refresh — the engine's controllers
// are all registered under a predict- prefix, and Stimulus derives the data
// attributes from that same string):
//   <div data-controller="predict-auto-refresh"
//        data-predict-auto-refresh-interval-value="10000"
//        data-predict-auto-refresh-active-value="<%= !@run.terminal? %>"></div>
//
// `active` defaults to true; set it to false for terminal pages so the
// controller no-ops without a separate erb conditional in the template.
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 10_000 },
    active:   { type: Boolean, default: true   },
  }

  connect() {
    if (!this.activeValue) return
    this.timer = setInterval(() => {
      Turbo.visit(window.location.href, { action: "replace" })
    }, this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }
}
